module.exports = __webpack_public_path__ + "img/map.0217ed64.png";